
export default {
  components: {
    'id-header-search': () => import('~/components/header/Search.vue')
  }
}
